module.exports = __webpack_public_path__ + "media/images/about/c_bg-ebdae514ef583d436b6b33cc15e57bc3.png";